export default __webpack_public_path__ + "static/media/filled-arrow-polygon-bottom.1868e0c0.svg";